import React, { Component } from 'react';
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { apiAuthen } from '../../services/api/auth';
import Swal from "sweetalert2";
import './style/login.scss';





class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: ""
        };
    }

    loginShop = async () => {
        let data = {
            "username" : this.state.username,
            "password" : this.state.password,
        }

        let resLogin = await apiAuthen(data)
        if (resLogin && resLogin.status) {
            // console.log(resLogin)
            localStorage.setItem("cus_id",resLogin.data.customer_id)
            localStorage.setItem("firstname",resLogin.data.first_name)
            localStorage.setItem("lastname",resLogin.data.last_name)
            if (resLogin.status == 200) {
                Swal.fire({
                    title: 'Succcess!',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 1000
                })

                setTimeout(() => { window.location.href = "/"}, 1000)

            } 
        }else{
            Swal.fire({
                title: 'Error!',
                text: resLogin.message,
                icon: 'error',
                showConfirmButton: false,
                timer: 1000
            })
        }

    }


    render() {




        return (
            <div className="cover-login">
                <div className="wh-bg">
                    <div className="container">
                        <Navbar />
                    </div>
                </div>

                <div className="box-login">
                    <div className="row half-box">
                        <div className="col-lg-6 col-md-6 col-12 col-login">
                            <div className="img-login">
                                <img className="img-fluid" src="/img/pic/img-login2.png" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 col-login">
                            <div className="box-form">
                                <p className="intro-login">ยินดีต้อนรับสู่ Nippy Marketplace</p>
                                <div className="cover-form">
                                    <div className="form-login">
                                        <div className="form-group">
                                            <input onChange={(e)=>{this.setState({username: e.target.value})}} className="form-control" placeholder="ชื่อผู้ใช้งาน" />
                                        </div>
                                        <div className="form-group">
                                            <input onChange={(e)=>{this.setState({password: e.target.value})}} type="password" className="form-control" placeholder="รหัสผ่าน" />
                                        </div>
                                        <button onClick={()=>{this.loginShop()}} className="btn btn-primary">LOGIN</button>
                                    </div>
                                    <p className="create-account">หรือ <a href="/create_user" className="link-create">สร้างบัญชีใหม่</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Login;
